import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid } from '@material-ui/core'
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en';
import Calendar from 'react-calendar';
import Ws from '../../providers/Ws';
import avatar from '../../Pics/avatar.jpg'



export default class AngajatiPrezenta extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidMount() {

    }


    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    maxWidth='md'
                    open={this.props.open}
                    onClose={this.props.dialogClose}>
                    <DialogActions >
                        <Fab onClick={this.props.dialogClose} className="pm-round-button-dialog">
                            <i className='material-icons pm-round-button-text-dialog'>close</i>
                        </Fab>
                    </DialogActions>
                    <h2 className='pm-dialog-alert-title'>Prezenta: {this.props.data}</h2>

                    <Grid container style={{maxHeight:'50 vh', overflow:'auto'}}  >

                        {this.props.listaAngajati.map((s, idx) => {
                            return (
                                <Grid key={idx} style={{ marginBottom: 20, textAlign:'center' }} className='pm-insert-task-item' item xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <div
                                        // onClick={()=>{this.selectFile(`file${s.id}`)}}
                                        onClick={() => { s.id_concediu === 0 && this.props.openDetaliiAngajat(s) }}
                                        className='pm-angajati-picture'
                                        style={{ backgroundImage: `url('${s.poza ? (new Ws().adresaMedia + '/Angajati/' + s.poza) : avatar}')` }}>

                                    </div>
                              

                                    <input id={`angInp${s.id}`}
                                        style={{ width: 'fit-content' }}
                                        className='pm-task-description-input'
                                        type='text'
                                        disabled={true}
                                        value={s.nume} />

                                    {s.absente > 0 ?
                                      <span style={{color:'rgb(241, 12, 116)'}}>Absent <i className='material-icons' style={{color:'rgb(241, 12, 116)',
                                      verticalAlign:'middle'}}>block</i></span>
                                  
                                    :
                                    s.nr_linii_pontaj > 0 ?
                                    (s.id_concediu > 0 ? 
                                        <span style={{color:'rgb(234, 125, 10)'}} >Concediu <i className='material-icons' style={{color:'rgb(234, 125, 10)',
                                        verticalAlign:'middle'}}>beach_access</i></span>   
                                        :
                                        <span style={{color:'#3ac13a'}} >Pontat <i className='material-icons' style={{color:'#3ac13a',
                                        verticalAlign:'middle'}}>done</i></span>   
                                        )
                                
                                  
                                    :
                                    <span>Ponteaza <i className='material-icons' onClick={()=>{ this.props.ponteazaPrimaLinie(s)}} style={{cursor:'pointer',
                                                                                        verticalAlign:'middle',
                                                                                        color:'gray'}}>crop_din</i></span>
                                }    

                                </Grid>
                            )
                        })}






                    </Grid>

                    <DialogActions className="pm-dialog-bottom-buttons">

                        <Button variant="outlined" onClick={this.props.salveaza} className='pm-save-button'>
                            {this.props.limba.comune.save}
                        </Button>




                    </DialogActions>


                </Dialog>
            </div>
        );
    }
}